export default 'https://tme.understood.org/assets/glowing_eye.6ed98e7d.glb'